import(/* webpackMode: "eager", webpackExports: ["SystemsIntegratorView"] */ "/vercel/path0/apps/www/app/[locale]/(site)/(legacy)/partners/systems-integrators/[slug]/_components/systems-integrator-view/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/Image/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useQuerySubscription/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useSiteSearch/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/VideoPlayer/index.js");
